import './Footer.css';
import facebook from '../../resources/bxl_facebook.png'
import twitter from '../../resources/twitter 1.png'
import linkedin from '../../resources/ant-design_instagram-outlined.png'

function Footer() {
    return (
        <footer className='padding_top green_gradient'>
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <div className='footer_main_div'>
                        <div className='footer_top_all_div'>
                            <div className='footer_logo_text_div'>
                                <p className='font_size_20 white_3'>Your ultimate tool for nutrition tracking, and wellness support.
                                    Start transforming your lifestyle today!</p>
                            </div>

                            <div className='flex gap_100'>
                                <div>
                                    <p className='font_size_22 font_weight_500 white'>Menu</p>
                                    <a href='/#home' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>Home</p>
                                    </a>
                                    <a href='/#home' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>Explore Recipes</p>
                                    </a>
                                    <a href='/#home' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>About us</p>
                                    </a>
                                    <a href='/#contact' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>Contact us</p>
                                    </a>
                                </div>
                                <div>
                                    <p className='font_size_22 font_weight_500 white'>Legal</p>
                                    <a href='/privacy-policy' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>Privacy Policy</p>
                                    </a>
                                    <a href='/terms-and-conditions' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>Terms & Conditions</p>
                                    </a>
                                    <a href='/cookie-policy' className='text_decoration_none'>
                                        <p className='footer_nav_p font_size_20 white_3'>Cookie Policy</p>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className='footer_divider'></div>

                        <div className='footer_copyright_div flex align_center justify_center'>
                            <p className='font_size_18 white_3'>© {new Date().getFullYear()} Revennt, LLC. All rights reserved.</p>

                            {/* <div className='flex align_center gap_20'>
                                <a href='/'>
                                    <img src={facebook} className='footer_social_icon' />
                                </a>
                                <a href='/'>
                                    <img src={linkedin} className='footer_social_icon' />
                                </a>
                                <a href='/'>
                                    <img src={twitter} className='footer_social_icon' />
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer >
    );
}

export default Footer;
